export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9533.478bc7c7.jpg";